export enum CreateStatus {
  'none' = 'none',
  'checkIfExistOnTarget' = 'checkIfExistOnTarget',
  'checkIfExistOnSirene' = 'checkIfExistOnSirene',
  'notExisting' = 'notExisting',
  'anonymized' = 'anonymized',
  'alreadyCreated' = 'alreadyCreated',
  'analyzing' = 'analyzing',
  'creating' = 'creating',
  'redirection' = 'redirection',
  'error' = 'error',
  'done' = 'done',
  'noDataFound' = 'noDataFound',
  'debug' = 'debug',
}
